import { Container, Paper } from "@mui/material";
import React from "react";
import CalendarView from "../views/Home/CalendarView";

const CalendarPage: React.FC = () => {
  return (
    <Container maxWidth="xl">
      <Paper sx={{ padding: 3 }}>
        <CalendarView />
      </Paper>
    </Container>
  );
};

export default CalendarPage;
